var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.$style['app-spinner'], {
		[_vm.$style['app-spinner--center']]: _vm.center
	}]},[_c('svg',{class:_vm.$style['app-spinner__svg'],attrs:{"width":_vm.width,"height":_vm.width,"viewBox":"0 0 66 66","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{class:_vm.$style['app-spinner__svg-path'],attrs:{"fill":"none","stroke-width":"6","cx":"33","cy":"33","r":"30"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }